import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Card, CardContent,
  Grid,
  LinearProgress, Typography, Button, Box, Stack,
} from '@mui/material';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DateInput from '../../BaseEditor/dates';
import { withLabel } from '../../BaseEditor/withLabel';
import { EditorControls } from '../../BaseEditor';
import { ErrorMessage } from '../../../components/Styled/Misc';
import { dateFormat } from '../../../api/utils';

const H2 = styled.h2`
  color: ${(props) => props.color};
`;

const LabeledDateInput = withLabel(DateInput);

function Notes({
  bdate,
  setBDate,
  edate,
  setEDate,
  kdb,
  setKdb,
  notesList,
  getNotes,
  err,
  isLoading,
}) {
  return (
    <>
      {isLoading && (
      <Box sx={{ width: '100%' }}>
        <LinearProgress />
      </Box>
      )}
      {err && (
      <ErrorMessage text={err} />
      )}
      <Box sx={{ width: '100%', display: 'flex', gap: '1rem' }}>
        <Box sx={{ flex: '0 0 auto', alignItems: 'center' }} display="flex">
          <Button variant="contained" color="info" onClick={getNotes}>Отримати платежі</Button>
        </Box>
        <Box sx={{ flex: '1 1 auto' }}>
          <Accordion>
            <AccordionSummary expandIcon={<FontAwesomeIcon icon={faAngleDown} />}>
              <Typography variant="subtitle2" style={{ marginRight: '2rem' }}>Опціональні параметри для відбору</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container spacing={3}>
                <Grid item sm={4}>
                  <LabeledDateInput
                    label="Дата початку"
                    value={bdate}
                    onChange={(e, v) => setBDate(v)}
                  />
                </Grid>
                <Grid item sm={4}>
                  <LabeledDateInput
                    label="Дата закінчення"
                    value={edate}
                    onChange={(e, v) => setEDate(v)}
                  />
                </Grid>
                <Grid item sm={4}>
                  <EditorControls.ItemPicker
                    label="КДБ"
                    backend="/api/catalog/kdbs/"
                    canErase
                    value={kdb}
                    onChange={(e, v) => setKdb(v)}
                    mode="no-repr"
                  />
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        </Box>
      </Box>

      {!err && notesList && (notesList.length ? (
        <Grid container spacing={4}>
          <Grid item sm={12}>
            <Typography variant="h4" color="primary">Список платежів</Typography>
          </Grid>
          {notesList.map((n) => (
            <Grid item sm={4} key={n.id}>
              <Card>
                <CardContent>
                  <Typography variant="caption">
                    {n.payment_notes}
                  </Typography>
                  <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Typography align="left" color="info" noWrap variant="subtitle2">
                      {dateFormat(n.date)}
                    </Typography>
                    <Typography align="left" color="info" noWrap variant="subtitle2">
                      КДБ:
                      {' '}
                      {n.document__account__kdb__code}
                    </Typography>
                    <Typography align="right" color="primary" noWrap variant="h5">
                      {n.order_amount.toLocaleString('uk', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                        useGrouping: true,
                      })}
                    </Typography>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      ) : <H2 color="red">На вказаний Вами період, нотаток немає</H2>)}
    </>
  );
}
Notes.propTypes = {
  bdate: PropTypes.string,
  setBDate: PropTypes.func.isRequired,
  edate: PropTypes.string,
  setEDate: PropTypes.func.isRequired,
  kdb: PropTypes.shape(),
  setKdb: PropTypes.func.isRequired,
  notesList: PropTypes.arrayOf(PropTypes.shape()),
  getNotes: PropTypes.func.isRequired,
  err: PropTypes.shape(),
  isLoading: PropTypes.bool.isRequired,
};

Notes.defaultProps = {
  bdate: null,
  edate: null,
  kdb: null,
  notesList: null,
  err: null,
};

export default Notes;
